<template>
  <div class="page dreaming">
    <div class="header">
      <img src="../../assets/images/activity/dream/header.png">
    </div>
    <div class="theme">
      <div class="theme-host">
        <img src="../../assets/images/activity/dream/title-icon-1.png">
        <span>易加网联合博修e路行推出</span>
        <img src="../../assets/images/activity/dream/title-icon-2.png">
      </div>
      <div class="theme-title">
        <img src="../../assets/images/activity/dream/theme-1.png">
      </div>
      <div class="theme-info">四重福利送不停</div>
      <div class="theme-time">活动时间 2020.7.1-12.31</div>
    </div>

    <div class="banner">
      <img src="../../assets/images/activity/dream/banner.png">
    </div>

    <div class="rule">
      <div class="rule-wrapper">
        <div class="color-bar">
          <span>1</span>
          <span>扫码获50积分</span>
        </div>

        <div class="rule-content">
          <div class="rule-content-prize">
            <img style="width: 70%"  src="../../assets/images/activity/dream/rule-1.png">
          </div>
          <div class="rule-content-info">扫描博世产品码<br>即可获得50积分</div>
        </div>
      </div>

      <div class="rule-wrapper">
        <div class="color-bar">
          <span>2</span>
          <span>点亮地图免费拿好礼</span>
        </div>

        <div class="rule-content">
          <div class="rule-content-icon padding-top-10">
            ×6期
          </div>
          <div class="rule-content-prize">
            <img src="../../assets/images/activity/dream/rule-2.png">
          </div>
          <div class="rule-content-info">完成博世地标点亮<br>6期免费送</div>
          <div class="rule-content-remark base-blue">* 集满100点心愿值可完成点亮</div>
        </div>
      </div>

      <div class="rule-wrapper">
        <div class="color-bar">
          <span>3</span>
          <span>扫码PK积分翻倍</span>
        </div>

        <div class="rule-content">
          <div class="rule-content-icon padding-top-10">
            ×2轮
          </div>
          <div class="rule-content-prize">
            <img src="../../assets/images/activity/dream/rule-3.png">
          </div>
          <div class="rule-content-info">当月扫码PK最佳<br> 积分翻倍</div>
          <div class="rule-content-remark base-blue">* 当月通过扫码获取的积分翻倍</div>
        </div>
      </div>

      <div class="rule-wrapper">
        <div class="color-bar">
          <span>4</span>
          <span>百万积分免费送</span>
        </div>

        <div class="rule-content">
          <div class="rule-content-icon">
            年度<br>大奖
          </div>
          <div class="rule-content-prize">
            <img src="../../assets/images/activity/dream/rule-4.png">
          </div>
          <div class="rule-content-info">全年扫码量<br>TOP5修理厂奖励</div>
          <div class="rule-content-remark base-blue">* 需完成6个博世地标点亮</div>
        </div>
      </div>

      <div class="footer">了解更多福利活动，请关注“易加网”公众号</div>
    </div>

    <van-popup v-model="popShow" :close-on-click-overlay="false">
      <div class="pop-content">
        <div class="pop-header">
          <img src="../../assets/images/activity/dream/pop-icon-1.png">
          <span>助</span>
          <img src="../../assets/images/activity/dream/pop-icon-2.png">
        </div>
        <div class="pop-content-info">
          <div class="font-size-16 pop-info-title">为好友 {{ clientName }} 助力</div>
          <div class="font-size-16 pop-info-content" v-html="content"></div>
        </div>
        <div v-if="type === 'succuss'" class="pop-btn">助力成功</div>
        <div v-else class="pop-btn" @click="handleHelp">帮他助力</div>
        <div class="pop-content-period">活动周期：{{ getPeriod() }}</div>
      </div>

      <div class="pop-close" @click="popShow = false">
        <img src="../../assets/images/activity/form-verification-off.png">
      </div>
    </van-popup>
  </div>
</template>

<script>
import activityApi from '@/api/activity'
import { sessionStorageUtils } from '@/utils/sessionstorage'
import { commonUtils } from '@/utils/common'
export default {
  name: 'ActivityDreamingSupport',
  data () {
    return {
      popShow: false,
      clientName: this.$route.query.clientName,
      type: '',
      content: '即可获得<span style="color: #ff4050; vertical-align: baseline;">1点</span>心愿值',
      timer: ''
    }
  },
  created () {
    this.initWxJsSdk()
  },
  mounted () {
    if (this.$route.query.clientId) {
      this.popShow = true
    }
  },
  destroyed () {
    clearTimeout(this.timer)
  },
  methods: {
    getPeriod () {
      const periodCode = this.$route.query.periodCode || ''
      const text = periodCode.substr(periodCode.length - 2, 2)
      return `2020.${text}`
    },
    handleHelp () {
      const wxUserInfo = sessionStorageUtils.get('wxUserInfo') || {}
      const data = {
        clientId: this.$route.query.clientId || '',
        periodCode: this.$route.query.periodCode || '',
        wxOpenId: wxUserInfo.openId || ''
      }
      activityApi.dreamingSupport(data).then(res => {
        if (res.data.resultCode === '0') {
          this.$notify({ type: 'success', message: '助力成功' })
          this.content = '感谢您的助力！'
          this.type = 'succuss'
        } else {
          this.$notify({
            background: '#1989fa',
            message: res.data.resultMsg,
            className: 'notify-error-msg'
          })
        }
      }).catch(() => {
        this.$toast.clear()
      })
    },
    initWxJsSdk () {
      const url = document.location.href

      const appMessageShare = {
        title: '梦想地图活动', // 分享标题
        desc: '梦想地图活动，助力赢好礼火热进行中', // 分享描述
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: process.env.VUE_APP_FILE_SERVER + '/static/dreaming-map.jpg', // 分享图标
        type: 'link', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: function () {
          // 用户点击了分享后执行的回调函数
          console.log('appMessageShare success' + url)
        },
        fail: function () {
          console.log('appMessageShare fail')
        }
      }

      const timelineShare = {
        title: '易加范活动', // 分享标题
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: process.env.VUE_APP_FILE_SERVER + '/static/dreaming-map.jpg', // 分享图标
        success: function () {
          // 用户点击了分享后执行的回调函数
          console.log('timelineShare success' + url)
        },
        fail: function () {
          console.log('appMessageShare fail' + url)
        }
      }
      commonUtils.configWxJsSdk(appMessageShare, timelineShare).then(() => {
        this.wxReady = true
      }).catch(error => {
        this.$emit('error', { errorMsg: error })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.base-blue {
  color: #629fde;
}
.page {
  position: relative;
  min-height: calc(100vh - 50px);
  padding-top: 0;
  padding-bottom: 50px;
  background: #162c7b;
  img {
    width: 100%;
  }
}
.header {
  position: relative;
  padding-bottom: 10px;
}

.theme {
  width: 100%;
  text-align: center;
  color: #fff;
  .theme-host {
    img {
      width: 50px;
    }
  }
  .theme-title {
    padding: 10px 0;
    margin: 0 auto;
    img {
      width: 200px;
    }
  }
  .theme-info {
    padding-bottom: 5px;
    font-size: 30px;
    font-weight: 600;
    font-style: italic;
  }
  .theme-time {
    width: 250px;
    height: 50px;
    margin: 0 auto;
    text-align: center;
    line-height: 50px;
    background: no-repeat center url('../../assets/images/activity/dream/title-time-bg.png');
    background-size: 100%;
  }
}
.rule {
  font-size: 12px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  text-align: center;
  .rule-wrapper {
    width: 160px;
    background-color: #fff;
    .color-bar {
      line-height: 30px;
      padding-left: 10px;
      font-weight: 600;
      color: #fff;
      text-align: left;
      background-image: linear-gradient(#26c2eb, #298ef6);
      span:nth-child(1) {
        display: inline-block;
        width: 20px;
        height: 20px;
        text-align: center;
        line-height: 20px;
        margin-right: 5px;
        color: #84b7fb;
        border-radius: 10px;
        background: #fff;
      }
    }
    .rule-content {
      position: relative;
      height: 130px;
      padding: 10px;
      text-align: center;
      border-right: 1px solid #84b7fb;
      .rule-content-prize {
        width: 110px;
        height: 80px;
        line-height: 80px;
        margin: auto;
        img {
          position: relative;
          z-index: 2;
          width: 100%;
          vertical-align: middle;
        }
      }
      .rule-content-info {
        font-size: 12px;
        padding: 5px;
        border-radius: 3px;
        color: #f93d34;
        background-color: #ffce3b;
      }
      .rule-content-icon {
        position: absolute;
        top: 0;
        right: 5px;
        color: #fff;
        width: 25px;
        height: 35px;
        background: no-repeat center url('../../assets/images/activity/dream/rule-icon.png');
        background-size: 100%;
        font-weight: 600;
        font-size: 10px;
        padding-top: 5px;
        box-sizing: border-box;
      }
      .rule-content-remark {
        padding-top: 5px;
        font-size: 10px;
      }
    }
  }
}
.footer {
  line-height: 50px;
  color: #fff;
}
.van-popup {
  width: 270px;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0);
  .pop-content {
    padding: 30px 20px;
    text-align: center;
    border-radius: 10px;
    background-color: #fff;
    .pop-content-img {
      // width: 200px;
      margin: 20px auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .pop-content-title {
      line-height: 30px;
      font-size: 20px;
      font-weight: 600;
    }
    .pop-content-info {
      line-height: 20px;
      text-align: left;
      .pop-info-title {
        padding: 20px 0;
        text-align:center;
        color: #999;
      }
      .pop-info-content {
        padding-bottom: 20px;
        text-align:center;
      }
    }
    .pop-content-period {
      padding-top: 10px;
      font-size: 12px;
      color: #999;
    }
    .pop-header {
      img {
        width: 40px;
      }
      span {
        display: inline-block;
        width: 50px;
        height: 50px;
        margin: 0 20px;
        line-height: 50px;
        border-radius: 25px;
        color: #fff;
        font-size: 16px;
        font-weight: 600;
        background: #fa5657;
      }
    }
    .pop-btn {
      width: 180px;
      height: 35px;
      margin: 0 auto;
      line-height: 35px;
      font-size: 16px;
      color: #fff;
      border-radius: 10px;
      background: #162c7b;
    }
  }
  .pop-close {
    width: 39px;
    height: 39px;
    margin: 32px auto 0 auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
